// @flow
import React from 'react';
import {Link} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import styles from './TopBarLogo.styles';

class TopBarLogo extends React.Component<Props> {
    render() {
      const {classes} = this.props;    
      return (
        <Link to="/" className={classes.logoLink}>
          <img
            className={classes.logoImage}
            src="/caffecinema/img/logo.jpg"
            alt="caffecinema"
          />
        </Link>
      );
    }
}

const Component = withStyles(styles)(TopBarLogo);
export {Component as TopBarLogo};
export default Component;